import React from "react";
import Accordion, { StaticAccordion } from "../../../components/Accordion";
import Money from "../../../components/Money";

const PortfolioValuationInvestmentSummaryWrapper = ({type="static", title="", value=0, allocation=0, children}) => {

    if(type == "accordion"){
        return(
            <Accordion className="py-4 px-6" titleClassName="bg-gradient-to-r from-primary-900 to-secondary-900 text-white px-6" title={(
                <table className="w-full table-fixed">
                    <thead>
                        <tr>
                            <th className="truncate md:w-[70%]">{title}</th>
                            <th className="text-right tabular-nums"><Money prefix={'£'} value={value} showNil={false} /></th>
                            <th className="text-right tabular-nums pr-4">{(allocation!= null) ? allocation.toFixed(0) + '%' : '0%'}</th>
                        </tr>
                    </thead>
                </table>
            )}>
              {children}
            </Accordion>
        )
    }

    return (
        <>
            <StaticAccordion className="py-4 px-6" titleClassName="bg-gradient-to-r from-primary-900 to-secondary-900 text-white px-6" title={(
                <table className="w-full table-fixed">
                    <thead>
                        <tr>
                            <th className="truncate md:w-[70%]">{title}</th>
                            <th className="text-right tabular-nums"><Money prefix={'£'} value={value} showNil={false} /></th>
                            <th className="text-right tabular-nums">{(allocation!= null) ? allocation.toFixed(0) + '%' : '0%'}</th>
                        </tr>
                    </thead>
                </table>
            )}>
              {children}
            </StaticAccordion>
        </>
    );
};

export default PortfolioValuationInvestmentSummaryWrapper;